import { render } from "./AttributionModal.vue?vue&type=template&id=4b623596&scoped=true"
import script from "./AttributionModal.vue?vue&type=script&lang=js"
export * from "./AttributionModal.vue?vue&type=script&lang=js"

import "./AttributionModal.vue?vue&type=style&index=0&id=4b623596&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b623596"]])

export default __exports__